<template>
  <div class="app-container">
    <div class="table-box">
      <el-form
        :model="queryParams"
        ref="queryForm"
        size="small"
        :inline="true"
        v-show="showSearch"
        label-width="68px"
      >
        <el-form-item label="公告标题" prop="noticeTitle">
          <el-input
            v-model="queryParams.noticeTitle"
            placeholder="请输入公告标题"
            clearable
            @keyup.enter.native="handleQuery"
          />
        </el-form-item>
        <el-form-item label="操作人员" prop="createBy">
          <el-input
            v-model="queryParams.createBy"
            placeholder="请输入操作人员"
            clearable
            @keyup.enter.native="handleQuery"
          />
        </el-form-item>
        <el-form-item label="类型" prop="noticeType">
          <el-select
            v-model="queryParams.noticeType"
            placeholder="公告类型"
            clearable
          >
            <el-option
              v-for="dict in sys_notice_type"
              :key="dict.value"
              :label="dict.label"
              :value="dict.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            icon="el-icon-search"
            size="mini"
            @click="handleQuery"
            >搜索</el-button
          >
          <el-button icon="el-icon-refresh" size="mini" @click="resetQuery"
            >重置</el-button
          >
        </el-form-item>
      </el-form>

      <el-row :gutter="10" class="mb8">
        <el-col :span="1.5">
          <el-button
            type="primary"
            plain
            icon="el-icon-plus"
            size="mini"
            @click="handleAdd"
            >新增</el-button
          >
        </el-col>
        <el-col :span="1.5">
          <el-button
            type="success"
            plain
            icon="el-icon-edit"
            size="mini"
            :disabled="single"
            @click="handleUpdate"
            >修改</el-button
          >
        </el-col>
        <el-col :span="1.5">
          <el-button
            type="danger"
            plain
            icon="el-icon-delete"
            size="mini"
            :disabled="multiple"
            @click="handleDelete"
            >删除</el-button
          >
        </el-col>
      </el-row>

      <el-table
        v-loading="loading"
        :data="noticeList"
        @selection-change="handleSelectionChange"
        max-height="680"
      >
        <el-table-column type="selection" width="55" align="center" />
        <el-table-column
          label="序号"
          align="center"
          prop="noticeId"
          width="100"
        />
        <el-table-column
          label="公告标题"
          align="center"
          prop="noticeTitle"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          label="公告类型"
          align="center"
          prop="noticeType"
          width="100"
        >
          <template slot-scope="scope">
            <span v-for="dict in sys_notice_type" :key="dict.value">
              <el-button
                v-if="dict.value == scope.row.noticeType"
                :type="dict.type"
                plain
                >{{ dict.label }}</el-button
              >
            </span>
          </template>
        </el-table-column>
        <el-table-column label="状态" align="center" prop="status" width="100">
          <template slot-scope="scope">
            <span v-for="dict in sys_notice_status" :key="dict.value">
              <el-button
                v-if="dict.value == scope.row.status"
                :type="dict.type"
                plain
                >{{ dict.label }}</el-button
              >
            </span>
          </template>
        </el-table-column>
        <el-table-column
          label="创建者"
          align="center"
          prop="createBy"
          width="100"
        />
        <el-table-column label="创建时间" align="center" prop="createTime">
          <template slot-scope="scope">
            <span>{{ scope.row.createTime }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          align="center"
          class-name="small-padding fixed-width"
        >
          <template slot-scope="scope">
            <el-button
              size="small"
              type="primary"
              icon="el-icon-edit"
              @click="handleUpdate(scope.row)"
              >修改</el-button
            >
            <el-button
              size="small"
              type="primary"
              icon="el-icon-delete"
              @click="handleDelete(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <pagination
        v-show="total > 0"
        :total="total"
        :page.sync="queryParams.pageNum"
        :limit.sync="queryParams.pageSize"
        @pagination="getList"
      />
    </div>

    <!-- 添加或修改公告对话框 -->
    <el-dialog :title="title" :visible.sync="open" width="780px" append-to-body>
      <el-form ref="form" :model="form" :rules="rules" label-width="80px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="公告标题" prop="noticeTitle">
              <el-input
                v-model="form.noticeTitle"
                placeholder="请输入公告标题"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="公告类型" prop="noticeType">
              <el-select v-model="form.noticeType" placeholder="请选择公告类型">
                <el-option
                  v-for="dict in sys_notice_type"
                  :key="dict.value"
                  :label="dict.label"
                  :value="dict.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="公告来源" prop="source">
              <el-input v-model="form.source" placeholder="请输入公告来源" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="状态" prop="status">
              <el-select v-model="form.status" placeholder="请选择公告状态">
                <el-option
                  v-for="dict in sys_notice_status"
                  :key="dict.value"
                  :label="dict.label"
                  :value="dict.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="内容">
              <editor v-model="form.noticeContent" :min-height="192" />
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item label="上传附件" prop="url">
              <file-upload
                :fileType="['pdf']"
                :limit="1"
                v-model="form.url"
                :uploadFileUrl="uploadFileUrl"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm">确 定</el-button>
        <el-button @click="cancel">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Axios from "axios";
import editor from "@/components/Editor/index.vue";
import FileUpload from "@/components/FileUpload/index.vue";
import pagination from "@/components/Pagination/index.vue";

export default {
  name: "Notice",
  components: { editor, FileUpload, pagination },
  data() {
    return {
      sys_notice_status: [
        {
          value: 0,
          label: "正常",
          type: "primary",
        },
        {
          value: 1,
          label: "关闭",
          type: "danger",
        },
      ],
      sys_notice_type: [
        {
          value: 1,
          label: "通知",
          type: "warning",
        },
        {
          value: 2,
          label: "公告",
          type: "success",
        },
      ],
      uploadFileUrl: "/hzyApi/hwDocking/uploadFile",
      // 遮罩层
      loading: true,
      // 选中数组
      ids: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      // 显示搜索条件
      showSearch: true,
      // 总条数
      total: 0,
      // 公告表格数据
      noticeList: [],
      // 弹出层标题
      title: "",
      // 是否显示弹出层
      open: false,
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
        sectionId: null,
        sectionName: null,
        syName: null,
        sn: null,
        reference: null,
        sort: null,
      },
      // 表单参数
      form: {},
      // 表单校验
      rules: {
        noticeTitle: [
          { required: true, message: "公告标题不能为空", trigger: "blur" },
        ],
        noticeType: [
          { required: true, message: "公告类型不能为空", trigger: "change" },
        ],
        source: [
          { required: true, message: "公告来源不能为空", trigger: "change" },
        ],
        status: [
          { required: true, message: "公告状态不能为空", trigger: "change" },
        ],
      },
      headers: {
        "Access-Token": this.$store.state.token,
      },
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    /** 查询公告列表 */
    getList() {
      this.loading = true;
      Axios.get("/hzyApi/hwDocking/getNotice", {
        params: this.queryParams,
        headers: this.headers,
      }).then((res) => {
        console.log("getNotice==res=====", res);
        if (res.data.code == 200) {
          this.noticeList = res.data.rows;
          this.total = res.data.total;
        }
      });
      this.loading = false;
    },
    // 取消按钮
    cancel() {
      this.open = false;
      this.reset();
    },
    // 表单重置
    reset() {
      this.form = {
        id: null,
        sectionId: null,
        sectionName: null,
        syName: null,
        sn: null,
        reference: null,
        sort: null,
      };
      this.resetForm("form");
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.getList();
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.resetForm("queryForm");
      this.handleQuery();
    },
    // 多选框选中数据
    handleSelectionChange(selection) {
      this.ids = selection.map((item) => item.noticeId);
      this.single = selection.length != 1;
      this.multiple = !selection.length;
    },
    /** 新增按钮操作 */
    handleAdd() {
      this.reset();
      this.open = true;
      this.title = "添加公告";
    },
    /** 修改按钮操作 */
    handleUpdate(row) {
      console.log("row---------", row);
      this.reset();
      const noticeId = row.noticeId || this.ids;
      Axios.get("/hzyApi/hwDocking/getNoticeInfoById", {
        params: { noticeId: noticeId },
        headers: this.headers,
      }).then((res) => {
        // console.log("res-getNoticeInfoById---", res)
        if (res.data.code == 200) {
          this.form = res.data.data;
          this.form.noticeType = this.sys_notice_type.filter(
            (val) => val.value == res.data.data.noticeType
          )[0].label;
          this.form.status = this.sys_notice_status.filter(
            (val) => val.value == res.data.data.status
          )[0].label;
          this.open = true;
          this.title = "修改公告";
        }
      });
    },
    /** 提交按钮 */
    submitForm: function () {
      this.form.createBy = this.$store.state.name;
      if (isNaN(Number(this.form.status))) {
        this.form.status = this.sys_notice_status.filter(
          (val) => val.label == this.form.status
        )[0].value;
      }
      if (isNaN(Number(this.form.noticeType))) {
        this.form.noticeType = this.sys_notice_type.filter(
          (val) => val.label == this.form.noticeType
        )[0].value;
      }
      this.$refs["form"].validate((valid) => {
        if (valid) {
          if (this.form.noticeId != undefined) {
            Axios.post("/hzyApi/hwDocking/editNotice", this.form, {
              params: this.form,
              headers: this.headers,
            }).then((res) => {
              console.log("res-editNotice---", res);
              if (res.data.code == 200) {
                this.$modal.msgSuccess("修改成功");
                this.open = false;
                this.getList();
              }
            });
          } else {
            Axios.post("/hzyApi/hwDocking/addNotice", this.form, {
              params: this.form,
              headers: this.headers,
            }).then((res) => {
              console.log("新增----res", res);
              if (res.data.code == 200) {
                this.$modal.msgSuccess("新增成功");
                this.open = false;
                this.getList();
              }
            });
          }
        }
      });
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      const noticeIds = row.noticeId || this.ids;
      let _this = this;
      this.$modal
        .confirm('是否确认删除公告编号为"' + noticeIds + '"的数据项？')
        .then(function () {
          Axios.post(
            "/hzyApi/hwDocking/removeNotice",
            { noticeId: noticeIds },
            {
              params: {
                noticeId: noticeIds,
              },
              headers: _this.headers,
            }
          )
            .then((res) => {
              // console.log("=======removeNotice======", res)
              if (res.data.code == 200) {
                _this.getList();
                _this.$modal.msgSuccess("删除成功");
              } else {
                _this.$modal.msgError("删除失败");
              }
            })
            .catch(() => {});
        });
    },
  },
};
</script>

<style scoped>
.table-box {
  height: 90vh;
  overflow: hidden;
}
</style>
